import React, { } from "react";
import { LabelModes } from "../../../../ui-components/molecules/labeled-inputs/labeledInput";
import {
    useFormikContext,
} from 'formik';
import XGSFormInput from "../../../../ui-components/form/input/xgsFormInput";
import XGSFormSelect from "../../../../ui-components/form/select/xgsFormSelect";
import usaStates from "../../../../app/data/common/usaStates";
import { AddEditAddress } from "app/data/address-manager/models";
import { countryOptions, timezoneOptions } from "app/data/terminal-details/models";

const AddressDetails = (): React.ReactElement => {

    const { values, setFieldValue } = useFormikContext<AddEditAddress>();

    return (<>
        <XGSFormInput
            type="text"
            name="line1"
            required={true}
            labelMode={LabelModes.column}
            label="Street Address Line 1"
        />
        <XGSFormInput
            type="text"
            name="line2"
            required={false}
            labelMode={LabelModes.column}     
            label="Street Address Line 2(Optional)"
        />
        <div className="add-edit-address-section__row-item">
            <XGSFormInput
                type="text"
                name="city"
                required={true}
                labelMode={LabelModes.column}           
                label="City"
                className="add-edit-address-section__width-50"
            />
            <XGSFormSelect
                label="State/Province"
                name="state"
                required={true}
                options={usaStates}
                value={values?.state ? usaStates.find(
                    (option) => option.value === values.state
                ) : null}
                onValueChange={(option) => {
                    setFieldValue("state", option?.value ?? "");
                }}
                formik             
                className="add-edit-address-section__width-50"
                labelMode={LabelModes.column}
            />
        </div>
        <div className="add-edit-address-section__row-item">
            <XGSFormSelect
                label="Country"
                name="country"
                options={countryOptions}
                value={values?.country ? countryOptions.find(
                    (option) => option.value === values.country
                ) : null}
                onValueChange={(option) => {
                    setFieldValue("country", option?.value ?? "");
                }}
                formik
                className="add-edit-address-section__width-50"
                labelMode={LabelModes.column}
            />
            <XGSFormInput
                type="text"
                name="zip"
                required={true}
                labelMode={LabelModes.column}
                label="ZIP/Postal Code"
                className="add-edit-address-section__width-50"
            />
        </div>
        <div className="add-edit-address-section__row-item">
            <XGSFormSelect
                label="Timezone"
                name="timezone"
                required={true}
                options={timezoneOptions}
                value={values?.timezone ? timezoneOptions.find(
                    (option) => option.value === values.timezone
                ) : null}
                onValueChange={(option) => {
                    setFieldValue("timezone", option?.value ?? "");
                }}
                formik
                className="add-edit-address-section__width-50"
                labelMode={LabelModes.column}
            />
        </div>
    </>)
};




export default AddressDetails;